/* eslint-disable no-console */
import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import Calendar from 'react-calendar';
import {
  // CongoWrapper, CongoHead, CongoContent, CongoImg, CongoDesc, CongoButton,
  CalendarWrapper, CalendarPicker,
 
} from "./styles";
import PropTypes from "prop-types";
import { getWellnessInterestByUserId, addUserLogWorkouts } from '../../redux/actions';
import Waiting from "../Waiting";
import { connect } from "react-redux";
// import { ImageUrl } from '../../utils/constants';
import { getMeters, getKilometers, fetchApi } from '../../utils/methods';
// import { NoComments } from "../SocialFeeds/styles";
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { AddUserLogWorkouts } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import {   CloseIconBranding, DistanceIcon, MilesDistanceIcon, NewLeftArrowIcon, NewNextArrowIconEventPage, NewRightArrowIcon, TimerIcon, UpArrowIcon, WorkoutResetIcon } from '../../utils/icons';
import { DisableEnableButton, Divider, HeaderText, LogWorkoutCard, NoBorderButton, ReservedButton, StyledBody, StyledModalWorkout, } from '../UserDashboard/styles';
import {TimerWrapper,TimerPicker,  TimerSemi, TimerSection,MilesPicker,IntensityWrapper, IntensityNameContainer, CalendarContainer} from '../UserDashboard/LogWorkoutPopupStyles';
import { showSuccessToast } from '../UserDashboard/ToastHelper';
import ShareWorkoutModal from './ShareWorkOutModal';
import Spinner from '../common/Spinner';
import LazyImage from '../common/LazyImage/LazyImage';
import {ImageUrl}  from '../../utils/constants';


class LogWorkoutCategoryV2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setDailyWorkout: false,
      selectedCategory: '',
      intensity: 0,
      activeField: [],
      optionDistance: {},
      optionTime: {},
      disable: [],
      selectedIndex: 0,
      showLogoutWorkoutCalendar: false,
      showLogWorkoutTimer: false,
      showLogWorkoutMiles: false,
      showLogWorkoutIntensity: false,
      showLogWorkoutCongo: false,
      currentDate: new Date(),
      percentage: 25,
      initialHour: "00",
      initialMinute: "00",
      initialSecond: "00",
      initialMilesOne: "00",
      initialMilesSecond: "00",
      initialScale: 25,
      initialScaleShow: 2.5,
      hideMiles: 0,
      interestName: '',
      selectedIntensity: null,
      workoutIcon:null,
    };
  }
  componentDidMount() {
    const { getWellnessInterestByUserId } = this.props;
    getWellnessInterestByUserId();

  }


  handleShowLogoutMiles = () => {
    const { initialHour, initialMinute, initialSecond } = this.state;
    const { hideMiles } = this.state;
    if ((Number(initialHour) || Number(initialMinute) || Number(initialSecond)) > 0) {
      if (hideMiles) {
        this.setState((prev) => ({
          showLogWorkoutTimer: !prev.showLogWorkoutTimer,
          showLogWorkoutMiles: !prev.showLogWorkoutMiles
        }))
      } else {
        this.setState((prev) => ({
          showLogWorkoutTimer: !prev.showLogWorkoutTimer,
          showLogWorkoutIntensity: !prev.showLogWorkoutIntensity
        }))
      }
    }
  }


  decrementHour = () => {
    const { initialHour } = this.state;
    if (Number(initialHour) === 0) {
      this.setState({
        initialHour: 12
      })
    }
    else {
      const updatedValue = Number(initialHour) - 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialHour:paddedValue})
    }
  }

  incrementHour = () => {
    const { initialHour } = this.state;
    if (Number(initialHour) === 12) {
      this.setState({
        initialHour: "00"
      })
    }
    else {
      const updatedValue = Number(initialHour) + 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialHour:paddedValue});
      // this.setState({
      //   initialHour: Number(initialHour) + 1
      // })
    }
  }

  onHourChange = (e)=>{

    const { initialHour } = this.state;
    if (Number(initialHour) > 12 || e.target.value > 12) {
      this.setState({
        initialHour: "00"
      })
    }
    else if(Number(initialHour) < 0 || e.target.value < 0){
      this.setState({
        initialHour: "00"
      })
    }
    else {
      const updatedValue = Number(e.target.value);
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialHour:paddedValue})
    }

  }

  decrementMinute = () => {
    const { initialMinute } = this.state;
    if (Number(initialMinute) === 0) {
      this.setState({
        initialMinute: 60
      })
    }
    else {
      const updatedValue = Number(initialMinute) - 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMinute:paddedValue});
      // this.setState({
      //   initialMinute: initialMinute - 1
      // })
    }
  }

  incrementMinute = () => {
    const { initialMinute } = this.state;
    if (Number(initialMinute) === 60) {
      this.setState({
        initialMinute: "00"
      })
    }
    else {
      const updatedValue = Number(initialMinute) + 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMinute:paddedValue});
      // this.setState({
      //   initialMinute: initialMinute + 1
      // })
    }
  }

  onMinuteChange=(e)=>{
    const { initialMinute } = this.state;
    if (Number(initialMinute) > 60 || e.target.value > 60) {
      this.setState({
        initialMinute: "00"
      })
    }
    else if (Number(initialMinute) < 0 || e.target.value < 0) {
      this.setState({
        initialMinute: "00"
      })
    }
    else {
      const updatedValue = Number(e.target.value);
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMinute:paddedValue})
    }

  }

  onWorkoutModalClose=()=>{
    // this.setState({showLogWorkoutCongo:false})
    this.setState((prev) => ({
      showLogWorkoutIntensity: false,
      showLogWorkoutCongo: !prev.showLogWorkoutCongo
    }));
    this.props.onHide();
    this.SuccessToast()
  }

  decrementSecond = () => {
    const { initialSecond } = this.state;
    if (Number(initialSecond) === 0) {
      this.setState({
        initialSecond: 60
      })
    }
    else {
      const updatedValue = Number(initialSecond) - 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialSecond:paddedValue});
      // this.setState({
      //   initialSecond: initialSecond - 1
      // })
    }
  }

  incrementSecond = () => {
    const { initialSecond } = this.state;
    if (Number(initialSecond) === 60) {
      this.setState({
        initialSecond: "00"
      })
    }
    else {
      const updatedValue = Number(initialSecond) + 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialSecond:paddedValue});
      // this.setState({
      //   initialSecond: initialSecond + 1
      // })
    }
  }

  onSecondChange=(e)=>{
    const { initialSecond } = this.state;
    if (Number(initialSecond) > 60 || e.target.value > 60) {
      this.setState({
        initialSecond: "00"
      })
    }
    else if (Number(initialSecond) < 0 || e.target.value < 0) {
      this.setState({
        initialSecond: "00"
      })
    }
    else {
      const updatedValue = Number(e.target.value);
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialSecond:paddedValue})
    }

  }


  


  logWorkoutTimer = () => {
    const { initialHour, initialMinute, initialSecond } = this.state;
    const isDisabled = (initialHour === "00" && initialMinute < "05");

    const { t } = this.props;
    return (
      <TimerWrapper>
        <div className="timeHeader">
          <div className="iconContainer">{TimerIcon()}</div>
          <div className="headingText">How long were you active today?</div>
        </div>

        <TimerPicker>
          <TimerSection>
            <div className="hourMinuteText">{t("Hour")}</div>
            <div className="picker">
              <div className='upArrowContainer' onClick={() => this.incrementHour()} >
                {UpArrowIcon()}
              </div>
              {/* <div>{initialHour < 10 ? `0${initialHour}` : initialHour}</div> */}
              <div className='time'><input className="numberText" type='number' value={initialHour} onChange={this.onHourChange}/></div>
              <div className='downArrowContainer' onClick={() => this.decrementHour()} >
                {UpArrowIcon()}
              </div>
            </div>
          </TimerSection>
          <TimerSemi>
            <div style={{display:"flex",flexDirection:"column"}}>
              <div className={'topdotMiles'}>.</div>
              <div className={'dotMiles'}>.</div>
            </div>
          </TimerSemi>
          <TimerSection>
            <div className="hourMinuteText"> {t("Min")}</div>
            <div className="picker">
              <div className='upArrowContainer' onClick={() => this.incrementMinute()} >
                {UpArrowIcon()}
              </div>
              {/* <div>{initialMinute < 10 ? `0${initialMinute}` : initialMinute}</div> */}
              <div className='time'><input className="numberText" type='number' value={initialMinute} onChange={this.onMinuteChange}/></div>
              <div className='downArrowContainer' onClick={() => this.decrementMinute()} >
                {UpArrowIcon()}
              </div>
            </div>
          </TimerSection>
          <TimerSemi>
            <div style={{display:"flex",flexDirection:"column"}}>
              <div className={'topdotMiles'}>.</div>
              <div className={'dotMiles'}>.</div>
            </div>
            {/* <div />
            <div>
              <img src="/public/images/NewDashboardV2/semiColon.png" alt="Timer Icon" />
            </div> */}
          </TimerSemi>
          <TimerSection>
            <div className="hourMinuteText">{t("Sec")}</div>
            <div className="picker">
              <div className='upArrowContainer' onClick={() => this.incrementSecond()} >
                {UpArrowIcon()}
              </div>
              {/* <div>{initialSecond < 10 ? `0${initialSecond}` : initialSecond}</div> */}
              <div className='time'><input type='number' className="numberText" value={initialSecond} onChange={this.onSecondChange} /></div>
              <div className='downArrowContainer' onClick={() => this.decrementSecond()} >
                {UpArrowIcon()}
              </div>
            </div>
          </TimerSection>
        </TimerPicker>
        <div className="noteText">You must enter at least 5 minutes.</div>
        <Divider isOpacity={"40%"} isMargin={"16px 0px 0px 0px"}></Divider>
        <DisableEnableButton   isCursor={!isDisabled}   margin={"16px auto 0px auto"}  active={!isDisabled} width="200px"  disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"} disabledColor={isDisabled ? "#989898" : "#FEFEFE"}   onClick={!isDisabled ? () => this.handleShowLogoutMiles() : null}>
          <div>{t("Next")}</div>
        </DisableEnableButton>
      </TimerWrapper>
    )
  }

  handleValue = (value) => {
    this.setState({ intensity: value });
  };

  clickIntensity = () => {
    const { workoutDate } = this.props;
    const { selectedCategory, initialHour, initialMinute, initialSecond, initialMilesOne,
      initialMilesSecond, initialScaleShow, currentDate
    } = this.state;
    const DistanceUnit = localStorage.getItem('DISTANCE');
    let meters = DistanceUnit === "KILOMETER"? getKilometers(parseFloat(`${Number(initialMilesOne)}.${Number(initialMilesSecond)}`)):getMeters(parseFloat(`${Number(initialMilesOne)}.${Number(initialMilesSecond)}`));
    let seconds =Number(initialHour) * 60 * 60 + Number(initialMinute) * 60 + Number(initialSecond);
    let obj = {};
    obj['workout_date'] =workoutDate ? workoutDate : moment(currentDate).format('YYYY-MM-DD');
    obj['interest_id'] = selectedCategory && selectedCategory['interest_id'];
    obj['distance'] = meters > 0 ? meters : 0;
    obj['time'] = seconds > 0 ? seconds : 0;
    obj['intensity'] = initialScaleShow;
    // addUserLogWorkouts(obj);
    this.saveChanges(obj);
    // this.setState((prev) => ({
    //   showLogWorkoutIntensity: !prev.showLogWorkoutIntensity,
    //   showLogWorkoutCongo: !prev.showLogWorkoutCongo
    // }))
  };

  SuccessToast = () => {
    showSuccessToast(`Great job, ${this.props.firstName}!`, `Your ${this.state.selectedCategory?.interest_name} workout is logged, and you've earned ${this.pointsEarned()} points!`);
  }

  saveChanges = async (workoutData) => {
    // setIsLoading(true);

    try {
      const res = await fetchApi(AddUserLogWorkouts, "POST", workoutData);

      if (res.status === "success") {
        this.setState((prev) => ({
          showLogWorkoutIntensity: !prev.showLogWorkoutIntensity,
          showLogWorkoutCongo: !prev.showLogWorkoutCongo,
          workoutData:res.data.workoutData,
          workoutIcon:res.data.workoutData.background_image
        }))
        this.props.GetTopCardsData();
        // this.SuccessToast()
        // toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      // setIsLoading(false);
    }
  };

  showLogWorkoutCalendar = (data) => {
    const {workoutDate} = this.props;
    const isCalendar = workoutDate === null;     // TRUE → show calendar
    const isTimer = workoutDate !== null;  
    this.setState((prev) => ({
      showLogWorkoutCalendar: isCalendar ? !prev.showLogWorkoutCalendar : prev.showLogWorkoutCalendar,
      showLogWorkoutTimer: isTimer ? !prev.showLogWorkoutTimer : prev.showLogWorkoutTimer,
      setDailyWorkout: !prev.setDailyWorkout,
      selectedCategory: data,
      hideMiles: data.show_distance,
      interestName: data.interest_name
    }))
  }

  showLogWorkoutTimer = () => {
    this.setState((prev) => ({
      showLogWorkoutTimer: !prev.showLogWorkoutTimer,
      showLogWorkoutCalendar: !prev.showLogWorkoutCalendar
    }))
  }

  handleShowLogoutCongo = () => {
    this.clickIntensity();
    this.setState((prev) => ({
      showLogWorkoutIntensity: !prev.showLogWorkoutIntensity,
      showLogWorkoutCongo: !prev.showLogWorkoutCongo
    }))
  }

  handleShowLogoutIntensity = () => {
    const { initialMilesOne, initialMilesSecond } = this.state;
    if ((Number(initialMilesOne) || Number(initialMilesSecond)) > 0) {
      this.setState((prev) => ({
        showLogWorkoutMiles: !prev.showLogWorkoutMiles,
        showLogWorkoutIntensity: !prev.showLogWorkoutIntensity
      }))
    }
  }

  decrementMilesOne = () => {
    const { initialMilesOne } = this.state;
    if (Number(initialMilesOne) === 0) {
      this.setState({
        initialMilesOne: "00"
      })
    }
    else {

      const { initialMilesOne } = this.state;
      const updatedValue = Number(initialMilesOne) - 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMilesOne:paddedValue});
      
      
    }
  }

  incrementMilesOne = () => {
    const { initialMilesOne } = this.state;
    const updatedValue = Number(initialMilesOne) + 1;
    const paddedValue = updatedValue.toString().padStart(2, '0');
    this.setState({initialMilesOne:paddedValue});
    // this.setState({
    //   initialMilesOne: initialMilesOne + 1
    // })
  }

  onMilesOneChange=(e)=>{
    const { initialMilesOne } = this.state;
    if (Number(initialMilesOne) < 0) {
      this.setState({
        initialMilesOne: "00"
      })
    }
    else {
      const updatedValue = Number(e.target.value);
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMilesOne:paddedValue})
    }

  }
  

  decrementMilesSecond = () => {
    const { initialMilesSecond } = this.state;
    if (Number(initialMilesSecond) === 0) {
      this.setState({
        initialMilesSecond: "00"
      })
    }
    else {
      const updatedValue = Number(initialMilesSecond) - 1;
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMilesSecond:paddedValue});
      // this.setState({
      //   initialMilesSecond: initialMilesSecond - 1
      // })
    }
  }

  incrementMilesSecond = () => {
    const { initialMilesSecond } = this.state;
    const updatedValue = Number(initialMilesSecond) + 1;
    const paddedValue = updatedValue.toString().padStart(2, '0');
    this.setState({initialMilesSecond:paddedValue});
    // this.setState({
    //   initialMilesSecond: initialMilesSecond + 1
    // })
  }

  onMilesSecondChange = (e)=>{
    const { initialMilesSecond } = this.state;
    if (Number(initialMilesSecond) < 0) {
      this.setState({
        initialMilesSecond: "00"
      })
    }
    else {
      const updatedValue = Number(e.target.value);
      const paddedValue = updatedValue.toString().padStart(2, '0');
      this.setState({initialMilesSecond:paddedValue})
    }

  }

  logWorkoutMiles = () => {
    const { initialMilesOne, initialMilesSecond } = this.state;
    const { t } = this.props;
    const DistanceUnit = localStorage.getItem('DISTANCE');

    const isDisabled = (initialMilesOne === "00");
    return (
    
      <TimerWrapper>
        <div className="timeHeader">
          <div className="iconContainer">{DistanceIcon()}</div>
          <div className="headingText">Workout Distance | How Far Did you go? {DistanceUnit === "KILOMETER"?t("(Kilometer)"):t("(Miles)")}</div>
        </div>
       
        
        {/* <MilesHead>{DistanceUnit === "KILOMETER"?t("kilometer"):t("Miles")}</MilesHead> */}
        <MilesPicker>
          <TimerSection>
            <div className="picker">
              <div className='upArrowContainer' onClick={() => this.incrementMilesOne()} >
                {UpArrowIcon()}
              </div>
              {/* <div>{initialMilesOne < 10 ? `0${initialMilesOne}` : initialMilesOne}</div> */}
              <div className='time'><input className="numberText" type='number' value={initialMilesOne} onChange={this.onMilesOneChange} /></div>
              <div className='downArrowContainer' onClick={() => this.decrementMilesOne()}>
                {UpArrowIcon()}
              </div>
            </div>
          </TimerSection>
          <div className={'dotMiles'}>.</div>
          <TimerSection>
            <div className="picker">
              <div className='upArrowContainer' onClick={() => this.incrementMilesSecond()} >
                {UpArrowIcon()}
              </div>
              {/* <div>{initialMilesSecond < 10 ? `0${initialMilesSecond}` : initialMilesSecond}</div> */}
              <div className='time'><input className="numberText" type='number' value={initialMilesSecond} onChange={this.onMilesSecondChange} /></div>
              <div className='downArrowContainer' onClick={() => this.decrementMilesSecond()}>
                {UpArrowIcon()}
              </div>
            </div>
          </TimerSection>
          <div />
        </MilesPicker>
        <Divider isOpacity={"40%"} isMargin={"16px 0px 0px 0px"}></Divider>
        <DisableEnableButton  isCursor={!isDisabled}  active={!isDisabled} margin={"0px auto 0px auto"} width="200px"  disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"} disabledColor={isDisabled ? "#989898" : "#FEFEFE"}   onClick={!isDisabled ? () => this.handleShowLogoutIntensity(): null}>
          <div>{t("Next")}</div>
        </DisableEnableButton>
      </TimerWrapper>
    )
  }

  handleFinalSubmit = () => {
    this.setState((prev) => ({
      showLogWorkoutCongo: !prev.showLogWorkoutCongo
    }))
  }

  pointsEarned = () => {
    let pointValue=0;
    const { initialMinute, initialHour } = this.state;

    if(Number(initialHour)>0){
      pointValue= Number(initialHour)*60;
    }
    if(Number(initialMinute)>0){
      pointValue=pointValue+Number(initialMinute);
    }
    return parseInt(pointValue / 5,10);
  }


  onChange = (value, event) => {
    event.preventDefault();
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
  
    if (value > today) {
      toast.error("You cannot log data for future dates.");
      return; 
    }
    this.setState({
      currentDate: value
    })
  }

  logWorkoutCalendar = () => {
    const { currentDate } = this.state;
    const today = new Date();
    const { t, user } = this.props;
    
    const registrationDateString = user && user.created_at ? moment(user.created_at).format("MM/DD/YYYY") : "NA";
    const registrationDate = registrationDateString !== "NA" ? moment(registrationDateString, "MM/DD/YYYY").toDate() : new Date();
    const isPrevDisabled = moment(currentDate).isSameOrBefore(moment(registrationDate), "month");

    const isNextDisabled = moment(currentDate).isSameOrAfter(moment(today), "month");
    const endOfCurrentMonth = moment().endOf('month').toDate();
    // Calculate 14 days ago
    // const fourteenDaysAgo = moment().subtract(14, "days").toDate();
   
    // FINAL: min allowed date
    //   const minAllowedDate =
    //  registrationDate > fourteenDaysAgo ? registrationDate : fourteenDaysAgo;

    return (
      <CalendarWrapper>
        <CalendarPicker>
          <CalendarContainer>
            <Calendar
              minDetail="decade"
              maxDetail="month"
              // view="month"
              defaultView="month"   
              showNeighboringMonth={true}
              onChange={(value, event) => this.onChange(value, event)}
              value={currentDate}
              maxDate={endOfCurrentMonth}
              minDate={registrationDate}
              // minDate={minAllowedDate}  
              // minDate={moment().subtract(14, 'days').toDate()}  // 14 days back from today
              // tileDisabled={({ date }) => date < registrationDate}
              formatMonthYear={(locale, date) =>
                moment(date).format("MMMM, YYYY")  
              }
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
              }
              // prevLabel={<NewLeftArrowIcon />}    
              prevLabel={
                isPrevDisabled
                  ? <NewLeftArrowIcon style={{ opacity: 0.3, pointerEvents: "none" }} />
                  : <NewLeftArrowIcon />
              }

              nextLabel={
                isNextDisabled
                  ? <NewRightArrowIcon  style={{ opacity: 0.3, pointerEvents: "none" }} />
                  : <NewRightArrowIcon  />
              }
              // nextLabel={<NewRightArrowIcon />}         
              prev2Label={null}              
              next2Label={null} 
            />
          </CalendarContainer>
        </CalendarPicker>
        <Divider isOpacity={"40%"} isMargin={"16px 0px 16px 0px"}></Divider>
        <ReservedButton active={1} width={"200px"} margin={"0px auto 0px auto"} onClick={() => this.showLogWorkoutTimer()}>
          <div>{t("Next")}</div>
        </ReservedButton>
      </CalendarWrapper>
    )
  }

  handleScaleChange = (data) => {
    let rounded = Math.round(data * 10) / 100;

    if (rounded > 0 && rounded <= 0.5) {
      rounded = 0.5
    } else if (rounded > 0.5 && rounded <= 1) {
      rounded = 1.0
    } else if (rounded > 1 && rounded <= 1.5) {
      rounded = 1.5
    } else if (rounded > 1.5 && rounded <= 2) {
      rounded = 2.0
    } else if (rounded > 2 && rounded <= 2.5) {
      rounded = 2.5
    } else if (rounded > 2.5 && rounded <= 3) {
      rounded = 3.0
    } else if (rounded > 3 && rounded <= 3.5) {
      rounded = 3.5
    } else if (rounded > 3.5 && rounded <= 4) {
      rounded = 4.0
    } else if (rounded > 4 && rounded <= 4.5) {
      rounded = 4.5
    } else if (rounded > 4.5 && rounded <= 5) {
      rounded = 5.0
    } else if (rounded > 5 && rounded <= 5.5) {
      rounded = 5.5
    } else if (rounded > 5.5 && rounded <= 6) {
      rounded = 6.0
    } else if (rounded > 6 && rounded <= 6.5) {
      rounded = 6.5
    } else if (rounded > 6.5 && rounded <= 7) {
      rounded = 7.0
    } else if (rounded > 7 && rounded <= 7.5) {
      rounded = 7.5
    } else if (rounded > 7.5 && rounded <= 8) {
      rounded = 8.0
    } else if (rounded > 8 && rounded <= 8.5) {
      rounded = 8.5
    } else if (rounded > 8.5 && rounded <= 9) {
      rounded = 9.0
    } else if (rounded > 9 && rounded <= 9.5) {
      rounded = 9.5
    } else if (rounded > 9.5 && rounded <= 10) {
      rounded = 10.0
    }
    this.setState({
      initialScale: data,
      initialScaleShow: rounded,
    })
  }

  handleWidth = (e) => {
    const box = document.querySelector("div.scaleImg");
    const rect = box.getBoundingClientRect();
    let val = ((e.clientX - rect.left) / rect.width) * 100;
    let rounded = Math.round(val * 10) / 100;

    if(val < 0){
      val = 0.5;
    }

    if (rounded > 0 && rounded <= 0.5) {
      rounded = 0.5
    } else if (rounded > 0.5 && rounded <= 1) {
      rounded = 1.0
    } else if (rounded > 1 && rounded <= 1.5) {
      rounded = 1.5
    } else if (rounded > 1.5 && rounded <= 2) {
      rounded = 2.0
    } else if (rounded > 2 && rounded <= 2.5) {
      rounded = 2.5
    } else if (rounded > 2.5 && rounded <= 3) {
      rounded = 3.0
    } else if (rounded > 3 && rounded <= 3.5) {
      rounded = 3.5
    } else if (rounded > 3.5 && rounded <= 4) {
      rounded = 4.0
    } else if (rounded > 4 && rounded <= 4.5) {
      rounded = 4.5
    } else if (rounded > 4.5 && rounded <= 5) {
      rounded = 5.0
    } else if (rounded > 5 && rounded <= 5.5) {
      rounded = 5.5
    } else if (rounded > 5.5 && rounded <= 6) {
      rounded = 6.0
    } else if (rounded > 6 && rounded <= 6.5) {
      rounded = 6.5
    } else if (rounded > 6.5 && rounded <= 7) {
      rounded = 7.0
    } else if (rounded > 7 && rounded <= 7.5) {
      rounded = 7.5
    } else if (rounded > 7.5 && rounded <= 8) {
      rounded = 8.0
    } else if (rounded > 8 && rounded <= 8.5) {
      rounded = 8.5
    } else if (rounded > 8.5 && rounded <= 9) {
      rounded = 9.0
    } else if (rounded > 9 && rounded <= 9.5) {
      rounded = 9.5
    } else if (rounded > 9.5 && rounded <= 10) {
      rounded = 10.0
    }
    else if (rounded <= 0 )
    {
      rounded = 0.5;
    }


    this.setState({
      initialScaleShow: rounded,
      initialScale: val
    })
  }

  intensityPoints = {
    "Relaxed": 2,
    "Mild": 4,
    "Moderate": 6,
    "Intense": 8,
    "Max Effort": 10
  }


  handleSelect = (name) => {

    this.setState({ selectedIntensity: name });
    let points = this.intensityPoints[name];
    this.setState({
      initialScaleShow: points,
    })

  };

  HandleReset = () => {
    this.setState({ selectedIntensity: null });
  };

  handleBack = () => {
    const {hideMiles} = this.state;

    if (hideMiles) {
      this.setState((prev) => ({
        // showLogWorkoutTimer: !prev.showLogWorkoutTimer,
        showLogWorkoutMiles: !prev.showLogWorkoutMiles,
        showLogWorkoutIntensity: !prev.showLogWorkoutIntensity
      }))
    } else {
      this.setState((prev) => ({
        showLogWorkoutTimer: !prev.showLogWorkoutTimer,
        showLogWorkoutIntensity: !prev.showLogWorkoutIntensity
      }))
    }
    // this.setState((prev) => ({
    //   showLogWorkoutIntensity: !prev.showLogWorkoutIntensity,
    //   showLogWorkoutTimer: !prev.showLogWorkoutTimer
    // }))
  }



  intensityData= [
    { name: "Relaxed", img: "Relaxed.png" },
    { name: "Mild", img: "Mild.png" },
    { name: "Moderate", img: "Moderate.png" },
    { name: "Intense", img: "Intense.png" },
    { name: "Max Effort", img: "Max_effort.png" },
  ]

  logWorkoutIntensity = () => {
    const { selectedIntensity  } = this.state;
    const isDisabled = selectedIntensity === null;
    const { t } = this.props;
    return (
      <IntensityWrapper>
        <div className="timeHeader">
          <div className="iconContainer">{MilesDistanceIcon()}</div>
          <div className="headingText">Workout Intensity Level</div>
        </div>
        <Divider isOpacity={"40%"} isMargin={"24px 0px 24px 0px"}></Divider>
        <div className="workoutText">How intense was your workout?</div>

        <IntensityNameContainer>
          {this.intensityData.map((item) => (
            <div
              key={item.name}
              className="selectedIntensity"
              onClick={() => this.handleSelect(item.name)}
              style={{
                background:
                  selectedIntensity === item.name ? "#F6D5D6" : "#FFFFFF", 
              }}
            >
              <img className="imageBox" src={`/public/images/NewDashboardV2/${item.img}`} alt="" />
              <div className="intensityText">{item.name}</div>
            </div>
          ))}
        </IntensityNameContainer>
        <Divider isOpacity={"40%"} isMargin={"24px 0px 16px 0px"}></Divider>
        <div className="buttonContainer">
          <NoBorderButton onClick={(()=> this.HandleReset())}>
            {WorkoutResetIcon()}
          </NoBorderButton>
          <NoBorderButton onClick={() => this.handleBack()}>
            <div>{("Back")}</div>
          </NoBorderButton>
        
          <DisableEnableButton  active={!isDisabled} isCursor={!isDisabled} disabledBg={isDisabled ? "#EFEFEF" : "#DA6C74"} disabledColor={isDisabled ? "#989898" : "#FEFEFE"}     width="200px" onClick={!isDisabled ?  this.clickIntensity : null}>
            <div>{t("Save Log Workout")}</div>
          </DisableEnableButton>
        </div>
      </IntensityWrapper>
    )
  }

  render() {
   
    const { setDailyWorkout, showLogWorkoutCalendar, showLogWorkoutTimer, showLogWorkoutMiles, showLogWorkoutIntensity, showLogWorkoutCongo, selectedCategory, workoutData,interestName } = this.state;
    const {  showModal, getLogWorkoutCategories, history,closeModal } = this.props;
    if (!getLogWorkoutCategories) {
      return <Waiting />;
    }

    const popupCss =(!setDailyWorkout && !showLogWorkoutCalendar && !showLogWorkoutTimer && !showLogWorkoutMiles && !showLogWorkoutIntensity)

    return (
      <>
        <StyledModalWorkout  maxHeight={ popupCss ? "466px" : "" }   isOverFlow={ popupCss ? "auto" : ""}   show={showModal && !showLogWorkoutCongo}  onHide={() => this.props.onHide()}   change={setDailyWorkout}  newWidth={showLogWorkoutCalendar ? "468px" : "600px"} >
          <Modal.Header>
            <HeaderText>
              <div className="subContainer">
                <div className="popupHeading"   style={{  margin: showLogWorkoutCalendar ? "auto" : ""}}>Log Workout {interestName ? `| ${interestName}` : null} </div>
                <div className="closeIcon" onClick={()=>closeModal()}>{CloseIconBranding("#DA6C74",14,14)}</div>
              </div>
            </HeaderText>
          </Modal.Header>
          <Divider isWidth={"93%"} isOpacity={"40%"} isMargin={"0px 20px"}></Divider>
  
          <StyledBody>
           
            {setDailyWorkout ?  null  : 
              <>
                <div className="gridContainer">
                  {getLogWorkoutCategories && getLogWorkoutCategories.length > 0 ? getLogWorkoutCategories.map((data,index) => (
                    <LogWorkoutCard key={index} onClick={() => this.showLogWorkoutCalendar(data)}>
                      <div className="firstContainer">
                        {/* <div className="iconContainer">{data['background_image']}</div> */}
                        <div className="iconContainer">
                          <LazyImage className="img" src={`${ImageUrl}/${data['background_image']}`} alt="icon" />
                        </div>
                        <div className="wellnessInterest" >{data['interest_name']}</div>
                      
                      </div>
                      <div className="iconContainer">{NewNextArrowIconEventPage("#DA6C74")}</div>
                    </LogWorkoutCard>)) : <div style={{display:"flex" ,justifyContent:"center", marginLeft:"auto"}}><Spinner color={"#DA6C74"}/> </div>}
                </div>
              </> 
            }


            {
              showLogWorkoutCalendar ? this.logWorkoutCalendar() : null
            }
            {
              showLogWorkoutTimer ? this.logWorkoutTimer() : null
            }
            {
              showLogWorkoutMiles ? this.logWorkoutMiles() : null
            }
            {
              showLogWorkoutIntensity ? this.logWorkoutIntensity() : null
            }
            
          </StyledBody>

          {!setDailyWorkout && !showLogWorkoutCalendar && !showLogWorkoutTimer && !showLogWorkoutMiles && !showLogWorkoutIntensity  &&
           <Modal.Footer>
             <div className="wrapper">
               <div className="redirectionText" onClick={() => history.push('/settings')}>{"Edit Wellness Interest >"}</div>
             </div>
           </Modal.Footer>}
         
        </StyledModalWorkout>
        {
          showLogWorkoutCongo ? <ShareWorkoutModal workoutIcon={this.state.workoutIcon} showModal={showLogWorkoutCongo} onClose={this.onWorkoutModalClose} workoutName={selectedCategory?.interest_name} workoutData={workoutData} history={history}/> : null
        }
      </>

    );
  }
}

LogWorkoutCategoryV2.propTypes = {
  showModal: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.string,
  subContent: PropTypes.string,
  getWellnessInterestByUserId: PropTypes.func,
  getLogWorkoutCategories: PropTypes.array,
  user: PropTypes.object,
  userId: PropTypes.number,
  history: PropTypes.object,
  addUserLogWorkouts: PropTypes.func,
  userName: PropTypes.string,
  firstName:PropTypes.string,
  response: PropTypes.object,
  t: PropTypes.func,
  closeModal: PropTypes.func,
  workoutDate: PropTypes.string.isRequired,
  GetTopCardsData: PropTypes.func,
};
const mapStateToProps = (state) => ({
  getLogWorkoutCategories: state.logWorkout.getLogWorkoutCategories,
  userId: state.profileData.userId,
  userName: state.profileData.userName,
  response: state.profileData.response,
  user: state.profileData.user,
});
const mapDispatchToProps = (dispatch) => ({
  getWellnessInterestByUserId: () => dispatch(getWellnessInterestByUserId()),
  addUserLogWorkouts: (data) => dispatch(addUserLogWorkouts(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogWorkoutCategoryV2));
